import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { Button } from 'ui-components/components/button';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import style from './style.module.less';
import { AutoBatchingContext } from './context';
import { PRE_PROCESSING, PROCESSED } from './constants/processing-state';
import { GENERAL_ERROR } from './constants/error-states';
import { useHistory } from 'react-router-dom';
import classnames from 'classnames';
import { useDispatch } from 'react-redux';
import { silentRequestGetOrders } from '../../../store/orders/orders.actions';
import { MAX_ALLOWED_ORDERS_PER_BATCH, MAX_ALLOWED_NUMBER_OF_BATCHES } from './constants/auto-batching-constants';

const AutoBatchFooter = ({ onCloseModal }) => {
  const { onGenerateBatches, processState, errorState, hasError, numberOfOrdersPerBatch, numberOfBatches, totalRecords } =
    useContext(AutoBatchingContext);
  const history = useHistory();
  const onViewBatches = useCallback(() => {
    history.push('/shipments/batches/open');
    onCloseModal();
  }, [onCloseModal, history]);
  const dispatch = useDispatch();
  const generateBatches = useCallback(() => {
    onGenerateBatches().then(() => dispatch(silentRequestGetOrders()));
  }, [onGenerateBatches, dispatch]);
  const hasExceededMax =
    numberOfOrdersPerBatch > MAX_ALLOWED_ORDERS_PER_BATCH ||
    numberOfOrdersPerBatch > totalRecords ||
    numberOfBatches > MAX_ALLOWED_NUMBER_OF_BATCHES - 1 ||
    numberOfBatches > totalRecords;

  return (
    <ModalFooter
      className={classnames(style.footer, {
        [style.initial]: processState === PROCESSED,
      })}
    >
      {processState === PRE_PROCESSING && (
        <>
          <Button onClick={onCloseModal} theme='tertiary'>
            <FormattedMessage {...messages.autoBatchingCancel} />
          </Button>
          <Button disabled={(hasError && errorState !== GENERAL_ERROR) || hasExceededMax} onClick={generateBatches} theme='primary'>
            <FormattedMessage {...messages.autoBatchingSubmissionAction} />
          </Button>
        </>
      )}
      {processState === PROCESSED && (
        <>
          <Button onClick={onCloseModal} theme='tertiary'>
            <FormattedMessage {...messages.autoBatchingClose} />
          </Button>
          <Button onClick={onViewBatches} theme='primary'>
            <FormattedMessage {...messages.autoBatchingViewBatches} />
          </Button>
        </>
      )}
    </ModalFooter>
  );
};

AutoBatchFooter.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
};

export default AutoBatchFooter;
